import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { Chart, registerables } from 'chart.js';
import moment from 'moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { MasterDataSeriveService } from '../../../../../Services/master-data-serive.service';
import {
  Categories,
  DateRangeModel,
  EmployeeReport,
  EmpReportQty,
  EmpReportsTotal,
  EmpReportTable,
  LoginModel,
  MainDepartment,
  RowData,
  Stores,
} from '../../../../../Models/ApplicationModels';
import { DatePipe } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { AdminBreadcrumbsService } from '../../../admin-services/admin-breadcrumbs.service';
import { ExportExcelService } from '../../../../../Services/export-excel.service';
import { OverrideStatus } from 'src/app/enum/enum';
import { CustomToastsService } from 'src/app/Services/custom-toasts.service';
import { ProductionCycle } from '../../../company-config/WeekColors/models/week-color.model';
import { WeekColorService } from '../../../company-config/WeekColors/services/week-color.service';
import { ReportsV3ApiService } from '../services/reports-v3-api.service';

@Component({
  selector: 'app-emp-reportsv3',
  templateUrl: './emp-reportsv3.component.html',
  styleUrls: ['./emp-reportsv3.component.css']
})
export class EmpReportsV3Component {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  @ViewChild('projectionV3') projection!: ElementRef<HTMLElement>;
  @ViewChild('totalItemV3') totalItem!: ElementRef<HTMLElement>;
  @ViewChild('preProducedV3') preProduced!: ElementRef<HTMLElement>;
  isDashboardTab: boolean = true;
  headerCheckboxSelected: boolean = false;
  gaugeValue = 0;
  gaugeLabel = 'goal achieved';
  gaugeAppendText = '%';
  gaugeColor: string = 'rgba(149, 164, 252, 1)';
  isSummary: boolean = false;
  charts: Chart[] = [];
  isEmployeLevelData: boolean = false;
  isProjectionData: boolean = false;
  isTotalValue: boolean = false;
  totalItemsCollected: number = 0;
  totalItemsPreProduced: number = 0;
  totalValueCollected: number = 0;
  totalItemCollectChart: any;
  totalItemPreProducedChart: any;
  projectionChartData: any;
  projectionChart: any = [];
  prevProjectionChart: any = [];
  projectionLabels: string[] = [];
  colorIndex: number = -1;
  reportType: string[] = ['store 1'];
  goalValueStr: string = 'Count';
  goalValue = [
    {
      goalValueID: 1,
      goalValue: 'Currency',
    },
    {
      goalValueID: 2,
      goalValue: 'Count',
    },
  ];
  empLevel = [
    {
      StoreID: 0,
      Name: '',
      Qty: 0,
      GoalCnt: 0,
      totalAchieved: 0,
      color: '',
      bg: '',
    },
  ];
  empLevel2 = [
    { name: 'Archie', level: 93, color: '#95A4FC', bg: '#95A4FC33' },
    { name: 'Kari', level: 85, color: '#BAEDBD', bg: '#BAEDBD33' },
    { name: 'Theodore', level: 81, color: '#1C1C1C', bg: '#1C1C1C33' },
    { name: 'Vicky', level: 80, color: '#B1E3FF', bg: '#B1E3FF33' },
    { name: 'Garrett', level: 76, color: '#A8C5DA', bg: '#A8C5DA33' },
  ];
  goalValueID: number = 2;
  reportTypeText: string = 'Outlet';
  outletOne: string = 'NYC-01';
  outletTwo: string = 'NYC-03';
  reportTypeOption: string = 'Store 1';
  isUser: boolean = false;
  deptName: string = 'All departments';
  categoryName: string = 'All categories';
  storeName: string = 'All stores';
  storeId: number = 0;
  deptNames: Array<string> = [];
  deptIDs: Array<number> = [];
  deptId: string = '0';
  categoryId: number = 0;
  startDate: any = '';
  endDate: any = '';
  reportHead: string = 'All departments / all categories';
  statData: any = [
    { title: 'Value', img: 'assets/pos/products/ic_upGrowth.svg', value: '$2.6k', growth: 6.08, background: '#E3F5FF' },
    { title: 'Pieces', img: 'assets/pos/products/ic_downGrowth.svg', value: '555', growth: 6.08, background: '#E5ECF6' },
    { title: 'Hours', img: 'assets/pos/products/ic_downGrowth.svg', value: '11.0', growth: 6.08, background: '#E3F5FF' },
    { title: '$/Hour', img: 'assets/pos/products/ic_upGrowth.svg', value: '555', growth: 6.08, background: '#E5ECF6' },
    { title: 'APOP', img: 'assets/pos/products/ic_upGrowth.svg', value: '$4.44', growth: 6.08, background: '#E3F5FF' },
  ];
  stores: Array<Stores> = [];
  mainDepartmentList: Array<MainDepartment> = [];
  categorieslist: Array<Categories> = [];
  userInfo: LoginModel = new LoginModel();
  noTableData: boolean = false;
  disableCategory: boolean = true;
  goalIntervalID: number = 4;
  isGoalData: boolean = true;
  // Resolved from GET /goals/intervals (task 14062) — never hardcoded, since the id is assigned by
  // whichever migration/seed created the "Hourly" tblGoalInterval row.
  hourlyGoalIntervalId: number | null = null;
  stackChartData: number[][] = [];
  stackChartDataPreProduced: number[][] = [];
  stackChartLabels: string[] = [];
  stackchartlabelsPreProduced: string[] = [];
  isTotalItemData: boolean = false;
  isPreProducedData: boolean = false;

  empReportPrices: any = [{ name: 'Stores', prices: [] }];
  empReportPricesexcel: any = [{ name: 'Stores', prices: [] }];
  MainStats = {
    qty: 0,
    totalHoursLogged: 0,
    value: 0,
    qtyGrowth: 0,
    valueGrowth: 0,
    apopGrowth: 0,
  };
  empDashboardDetails: any = [];
  empReportsQtys: Array<EmpReportQty> = [];
  empReportsQtysexcel: Array<EmpReportQty> = [];
  tblReportsTotal: EmpReportsTotal = new EmpReportsTotal();
  tblReportsTotalExcel: EmpReportsTotal = new EmpReportsTotal();
  weekColorHeaderSelected: boolean = false;
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  productionCycleId: number = 0;
  showWeekColor: boolean = true;
  dateRangeModal: DateRangeModel = new DateRangeModel();
  @Output() dateRangeSelected = new EventEmitter<DateRangeModel>();
  isLoadingEmpDashboard: boolean = false;
  isLoadingTable: boolean = false;
  pageSize = 5;
  currentPage = 1;
  reportHasRun: boolean = false;

  constructor(
    private toaster: CustomToastsService,
    private masterService: MasterDataSeriveService,
    private datepipe: DatePipe,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private exportExcelService: ExportExcelService,
    private reportsV3Service: ReportsV3ApiService,
    private weekColorService: WeekColorService
  ) { }

  async ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      { crumbName: 'Employee Report', link: '/admin/home/v3/emp-report' },
    ]);

    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (this.userInfo as any)?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    this.getMainDepartments();
    this.getHourlyGoalIntervalId();
    this.startDate = moment().format('MM-DD-YYYY');
    this.endDate = moment().format('MM-DD-YYYY');
    this.productionCycleId = 0;
  }

  getHourlyGoalIntervalId() {
    this.masterService.getGoalIntervals().subscribe((res: any) => {
      const intervals = Array.isArray(res) ? res : [];
      // dbo.tblGoalInterval seeds the row as "Hourly Goals" (GoalIntervalID = 4) — match by
      // substring so this also works if an environment seeded it under a plain "Hourly" name.
      const hourly = intervals.find((item: any) =>
        (item.goalIntervals ?? '').toString().trim().toLowerCase().includes('hourly')
      );
      // Falls back to the confirmed GoalIntervalID = 4 if the lookup hasn't resolved yet/failed,
      // rather than silently disabling Hour goal data.
      this.hourlyGoalIntervalId = hourly ? hourly.goalIntervalId : 4;
    });
  }

  /*date range picker */
  public options: any = {
    locale: { format: 'MM/DD/YYYY', separator: ' - ' },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: false,
    maxDate: new Date(),
    autoApply: true,
    isInvalidDate: () => true,
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment()],
      'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    },
    opens: 'left',
  };

  public selectedDate() {
    this.startDate = this.dateRangeModal.fromDate;
    this.endDate = this.dateRangeModal.toDate;
    switch (this.dateRangeModal.Measure) {
      case 'hour': this.goalIntervalID = 4; this.isGoalData = true; break;
      case 'day': this.goalIntervalID = 1; this.isGoalData = true; break;
      case 'week': this.goalIntervalID = 2; this.isGoalData = true; break;
      case 'month': this.goalIntervalID = 3; this.isGoalData = true; break;
      case 'custom': this.goalIntervalID = 0; this.isGoalData = false; break;
      default: return;
    }
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  toggleDashboardTabs(opt: boolean) {
    if (this.isDashboardTab !== opt) {
      this.isDashboardTab = opt;
    }
  }

  getStores() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.masterService.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        for (let item of res) {
          this.stores.push(item);
        }
      }
    });
  }

  getMainDepartments() {
    this.masterService.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => { this.mainDepartmentList = Response as MainDepartment[]; },
      (err) => { }
    );
  }

  getCategoriesByDeptId(deptId: number) {
    this.masterService.getCategoriesByDeptUserID(deptId, this.userInfo.userId, false, 0).subscribe((res) => {
      this.categoryName = 'All categories';
      this.categorieslist = res as Categories[];
    });
  }

  getWeekColors() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.weekColorService.getProductionCycles(user.companyID).subscribe((res) => {
      this.weekColorsList = res as ProductionCycle[];
      this.weekColorsList = this.weekColorsList.filter((item) => item.status === OverrideStatus.Active);
    });
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    if (!this.disableCategory) this.disableCategory = true;
    this.deptNames = [];
    this.mainDepartmentList.forEach((dept) => {
      dept.isSelected = this.headerCheckboxSelected;
      if (this.headerCheckboxSelected) {
        this.deptNames.push(dept.departmentDescr);
      }
    });
    if (!this.headerCheckboxSelected) this.deptNames = [];
    this.deptIDs = this.headerCheckboxSelected
      ? this.mainDepartmentList.map((dept) => dept.departmentId)
      : [];
    if (this.deptIDs.length) {
      this.deptId = this.deptIDs.join(', ');
      this.deptName = 'All departments';
    } else {
      this.deptName = 'All departments';
      let allIDs = this.mainDepartmentList.map((dept) => dept.departmentId);
      this.deptId = allIDs.join(', ');
    }
  }

  toggleAllColors() {
    this.weekColorHeaderSelected = !this.weekColorHeaderSelected;
    if (!this.disableCategory) this.disableCategory = true;
    if (!this.weekColorHeaderSelected) this.productionCycleId = 0;
  }

  selectAllStores() { this.storeName = 'All stores'; this.storeId = 0; }
  selectAllcolors() { this.weekColor = 'All Week Colors'; this.productionCycleId = 0; }

  selectAllcategories() {
    if (this.categorieslist.length) {
      let index = this.reportHead.indexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index);
      }
      this.categoryName = 'All categories';
      this.categoryId = 0;
    }
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      this.storeName = filterObj.storeName;
      this.storeId = filterObj.storeId;
    }
    if (option === 2) {
      const nameIndex = this.deptNames.findIndex((item) => item === filterObj.departmentDescr);
      this.reportHead = '';
      if (nameIndex !== -1) {
        this.deptNames.splice(nameIndex, 1);
        this.reportHead = this.deptNames[nameIndex - 1];
      } else {
        this.deptNames.push(filterObj.departmentDescr);
        this.reportHead = filterObj.departmentDescr;
      }
      if (this.deptNames.length > 1) {
        this.deptName = this.deptNames.slice(0, 1) + ' +' + `${this.deptNames.length - 1}`;
      } else {
        this.deptName = this.deptNames.join(', ');
      }
      const iDIndex = this.deptIDs.indexOf(filterObj.departmentId);
      if (iDIndex !== -1) {
        this.deptIDs.splice(iDIndex, 1);
      } else {
        this.deptIDs.push(filterObj.departmentId);
      }
      if (this.deptIDs.length > 1) this.disableCategory = true;
      else this.disableCategory = false;
      if (this.deptIDs.length) {
        this.deptId = this.deptIDs.join(', ');
        if (this.deptIDs && this.deptIDs.length > 0) {
          this.getCategoriesByDeptId(this.deptIDs[this.deptIDs.length - 1]);
        }
      } else {
        this.deptName = 'All departments';
        this.deptId = '0';
        this.disableCategory = true;
      }
    }
    if (option === 3) {
      if (this.categoryName) {
        this.reportHead = (this.reportHead ?? '').split('/')[0].trim();
      }
      this.categoryName = filterObj.categoryName;
      this.categoryId = filterObj.categoryId;
      this.reportHead += ' / ' + filterObj.categoryName;
    }
    if (option === 4) {
      this.goalValueStr = filterObj.goalValue;
      this.goalValueID = filterObj.goalValueID;
    }
    if (option == 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.id;
    }
  }

  runReport() {
    this.reportHasRun = true;
    this.updateChart();
  }

  get isRunning(): boolean {
    return this.isLoadingEmpDashboard || this.isLoadingTable;
  }

  async updateChart() {
    if (this.isDashboardTab) {
      this.destroyCharts();
      await this.getEmpDashboard();
    } else {
      await this.getEmpReporTable();
    }
  }

  days: number = 0;

  async getEmpDashboard() {
    this.destroyCharts();
    this.isLoadingEmpDashboard = true;
    const formattedStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
    const formattedEndDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');
    if (this.deptIDs.length > 1 || this.deptIDs.length == 0) this.categoryId = 0;

    this.reportsV3Service.getEmployeeSummaryV3(
      this.userInfo.companyID,
      this.storeId,
      this.deptId,
      this.goalValueID,
      this.goalIntervalID,
      this.categoryId,
      formattedStartDate,
      formattedEndDate,
      this.productionCycleId
    ).subscribe({
      next: (raw: any) => {
        // Map V3 flat response into the V2 shape that all downstream logic expects
        const v3Goals: any[] = raw?.userGoals ?? [];
        const v3Projections: any[] = raw?.projections ?? [];
        const v3PrevProjections: any[] = raw?.previousProjections ?? [];
        const v3TotalValues: any[] = raw?.totalValuesByStore ?? [];
        const v3TotalItems: any[] = raw?.totalItems ?? [];
        const v3TotalItemsPreProduced: any[] = raw?.totalItemsPreProduced ?? [];

        this.empDashboardDetails = {
          stats: raw?.stats
            ? [{ qty: raw.stats.totalQuantity ?? 0, value: raw.stats.totalAmount ?? 0, totalHoursLogged: raw.stats.totalHoursLogged ?? 0 }]
            : [],
          prevStat: raw?.previousStats
            ? [{ qty: raw.previousStats.totalQuantity ?? 0, value: raw.previousStats.totalAmount ?? 0, totalHoursLogged: raw.previousStats.totalHoursLogged ?? 0 }]
            : [{ qty: 0, value: 0 }],
          goalAvg: v3Goals.map((g: any) => ({ GoalCnt: g.goalCount ?? 0, Qty: g.quantity ?? 0 })),
          goal: v3Goals.map((g: any) => ({ StoreID: g.id, Name: g.name, Qty: g.quantity ?? 0, GoalCnt: g.goalCount ?? 0 })),
          projection: v3Projections.map((p: any) => ({ createdDt: p.createdDate, Qty: p.quantity ?? 0 })),
          prevprojection: v3PrevProjections.map((p: any) => ({ createdDt: p.createdDate, Qty: p.quantity ?? 0 })),
          totalValue: v3TotalValues.map((s: any) => ({ Name: s.name, TotalValue: s.totalAmount ?? 0 })),
          totalItems: v3TotalItems.map((s: any) => ({ ID: s.id, Name: s.name, Price: s.price ?? 0, Qty: s.quantity ?? 0 })),
          totalPreProduced: v3TotalItemsPreProduced.map((s: any) => ({ ID: s.id, Name: s.name, Price: s.price ?? 0, Qty: s.quantity ?? 0 })),
        };

        // ---- from here the logic is identical to V2 ----
        if (
          this.empDashboardDetails.stats &&
          this.empDashboardDetails.stats.length > 0 &&
          this.empDashboardDetails.stats[0]?.qty != null &&
          this.empDashboardDetails.stats[0]?.value != null
        ) {
          const mainStats = this.empDashboardDetails.stats[0];
          this.MainStats = mainStats;

          const prevStats = this.empDashboardDetails.prevStat[0];
          const currentApop = mainStats.value / mainStats.qty;
          const prevApop = prevStats?.value && prevStats?.qty ? prevStats.value / prevStats.qty : 0;

          this.MainStats.totalHoursLogged = parseFloat((this.MainStats.totalHoursLogged ?? 0).toFixed(2));
          this.MainStats.qtyGrowth = parseInt(
            ((((mainStats?.qty ?? 0) - (prevStats?.qty ?? 0)) / (prevStats?.qty ?? 1)) * 100).toFixed(2)
          );
          this.MainStats.valueGrowth = parseInt(
            ((((mainStats?.value ?? 0) - (prevStats?.value ?? 0)) / Math.max(prevStats?.value ?? 1, 1)) * 100).toFixed(2)
          );
          this.MainStats.apopGrowth = parseInt(
            ((((currentApop ?? 0) - (prevApop ?? 0)) / Math.max(prevApop ?? 1, 1)) * 100).toFixed(2)
          );
        } else {
          this.setDefaultMainStats();
        }

        /*gauge*/
        if (this.empDashboardDetails.goal?.length) {
          let totalGoalCount = 0;
          let totalAchieved = 0;
          this.empDashboardDetails.goal.forEach((item: any) => {
            totalGoalCount += item.goalCount || item.GoalCnt || 0;
            totalAchieved += item.qty || item.Qty || 0;
          });
          this.gaugeValue = totalGoalCount > 0
            ? parseFloat(((totalAchieved / totalGoalCount) * 100).toFixed(2))
            : 0;
        } else if (this.empDashboardDetails.goalAvg?.length) {
          const goalAvg = this.empDashboardDetails.goalAvg;
          let goalCnt: any = 0;
          let totalAchieved: any = 0;
          goalAvg.forEach((item: any) => {
            goalCnt += item.GoalCnt || item.goalCount || 0;
            totalAchieved += item.Qty || item.qty || 0;
          });
          this.gaugeValue = goalCnt > 0
            ? parseFloat(((totalAchieved / goalCnt) * 100).toFixed(2))
            : 0;
        } else {
          this.gaugeValue = 0;
        }

        /*store / employee level*/
        this.empLevel = this.empDashboardDetails.goal;
        if (this.empDashboardDetails.goal.length) {
          this.isEmployeLevelData = true;
        } else {
          this.isEmployeLevelData = false;
        }
        this.empLevel.forEach((item: any) => {
          item.totalAchieved = item.GoalCnt
            ? parseFloat(((item.Qty! / item.GoalCnt) * 100).toFixed(2))
            : 0;
          item.color = this.randomColor();
          item.bg = item.color + '33';
        });

        if (this.empDashboardDetails.projection.length) {
          this.isProjectionData = true;
          const startDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd');
          const endDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd');
          if (startDate === endDate) {
            this.empDashboardDetails.projection.forEach((item: any) => {
              this.projectionLabels.push(
                new Date(item.createdDt).toLocaleTimeString('en-US', { hour: 'numeric', hour12: true })
              );
            });
            this.projectionLabels = Array.from(new Set(this.projectionLabels));
            this.projectionChart = this.createProjectionChartByHours(this.empDashboardDetails.projection);
            this.prevProjectionChart = this.createProjectionChartByHours(this.empDashboardDetails.prevprojection);
          } else {
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            this.projectionLabels = this.empDashboardDetails.projection.map(
              (item: { createdDt: string | number | Date }) => {
                const date = new Date(item.createdDt);
                const day = days[date.getDay()];
                const dayOfMonth = date.getDate();
                return `${day} ${dayOfMonth}`;
              }
            );
            this.projectionLabels = Array.from(new Set(this.projectionLabels));
            this.prevProjectionChart = this.createProjectionChart(this.empDashboardDetails.prevprojection);
            this.projectionChart = this.createProjectionChart(this.empDashboardDetails.projection);
          }
        } else {
          this.isProjectionData = false;
        }

        if (this.empDashboardDetails.totalValue.length) {
          this.isTotalValue = true;
          this.empDashboardDetails.totalValue.forEach((item: any) => {
            this.totalValueCollected += item.TotalValue;
          });
        } else {
          this.isTotalValue = false;
        }

        if (this.empDashboardDetails.totalItems.length) {
          this.isTotalItemData = true;
        } else {
          this.isTotalItemData = false;
        }

        this.isPreProducedData = this.empDashboardDetails.totalPreProduced.length ? true : false;

        this.stackChartLabels = Array.from(
          new Set(this.empDashboardDetails.totalItems.map((item: { Name: any }) => item.Name))
        );
        this.stackchartlabelsPreProduced = Array.from(
          new Set(this.empDashboardDetails.totalPreProduced.map((item: { Name: any }) => item.Name))
        );
        this.generateStackChartData();
        this.generateStackChartDataPreProduced();

        if (this.stackChartData.length) {
          this.empDashboardDetails.totalItems.forEach((item: any) => {
            this.totalItemsCollected += item.Qty;
          });
        }

        setTimeout(() => { this.renderChart(); }, 0);
      },
      complete: () => { this.isLoadingEmpDashboard = false; },
    });
  }

  setDefaultMainStats() {
    this.MainStats = { qty: 0, totalHoursLogged: 0, value: 0, qtyGrowth: 0, valueGrowth: 0, apopGrowth: 0 };
    this.days = 0;
  }

  async getEmpReporTable() {
    this.isLoadingTable = true;
    const formattedStartDate = this.datepipe.transform(this.startDate, 'yyyy-MM-dd HH:mm:ss');
    const formattedEndDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss');

    try {
      const res: any = await firstValueFrom(
        this.reportsV3Service.getEmployeeTableV3(
          this.userInfo.companyID,
          this.storeId,
          this.deptId,
          this.categoryId,
          formattedStartDate,
          formattedEndDate,
          this.productionCycleId,
          this.goalIntervalID
        )
      );

      this.pageSize = 5;
      this.currentPage = 1;

      if (res && res.items && res.items.length) {
        this.noTableData = false;
        this.empReportPrices[0].name = this.storeId === 0 ? 'Stores' : 'Employee';
        // V3 items are shaped {id (storeId), storeName, username, price, quantity, userId} — remap to the V2 EmployeeReport shape below
        const mappedItems = res.items.map((item: any) => ({
          storeId: item.id,
          storeName: item.storeName,
          userId: item.userId,
          userName: item.username,
          totalAmount: item.price ?? 0,
          totalQuantity: item.quantity ?? 0,
          totalHoursLogged: 0,
        }));
        this.formateReportTableData({ items: mappedItems });
      } else {
        this.noTableData = true;
      }
    } catch (err) {
      console.error('Error fetching employee report (v3):', err);
      this.noTableData = true;
    } finally {
      this.isLoadingTable = false;
    }
  }

  formatDate(date: any): string {
    return date.toISOString().split('T')[0];
  }

  createProjectionChartByHours(projection: any[]): any[] {
    const projectionChartByHours: any[] = [];
    const hourMap = new Map<string, number>();
    projection.forEach((proj) => {
      const hour = new Date(proj.createdDt).getHours().toString();
      if (hourMap.has(hour)) {
        hourMap.set(hour, hourMap.get(hour)! + proj.Qty);
      } else {
        hourMap.set(hour, proj.Qty);
      }
    });
    hourMap.forEach((qty, hour) => { projectionChartByHours.push({ Hour: hour, Qty: qty }); });
    return projectionChartByHours;
  }

  createProjectionChart(projection: any[]): any[] {
    const projectionChart: any[] = [];
    const projectionMap = new Map<string, number>();
    projection.forEach((proj) => {
      const date = proj.createdDt.includes('T') ? proj.createdDt.split('T')[0] : proj.createdDt;
      if (projectionMap.has(date)) {
        projectionMap.set(date, projectionMap.get(date)! + proj.Qty);
      } else {
        projectionMap.set(date, proj.Qty);
      }
    });
    projectionMap.forEach((qty, date) => { projectionChart.push({ createdDt: date, Qty: qty }); });
    return projectionChart;
  }

  generateStackChartData(): void {
    const uniquePrices = Array.from(
      new Set(this.empDashboardDetails.totalItems.map((item: { Price: any }) => item.Price))
    ).sort((a: any, b: any) => a - b);
    const uniqueStores = Array.from(
      new Set(this.empDashboardDetails.totalItems.map((item: { ID: any }) => item.ID))
    );
    uniquePrices.forEach((price) => {
      const priceData: number[] = [];
      uniqueStores.forEach((store) => {
        const qty = this.empDashboardDetails.totalItems
          .filter((item: { Price: unknown; ID: unknown }) => item.Price === price && item.ID === store)
          .reduce((acc: any, curr: { Qty: any }) => acc + curr.Qty, 0);
        priceData.push(qty);
      });
      this.stackChartData.push(priceData);
    });
  }

  generateStackChartDataPreProduced(): void {
    const uniquePrices = Array.from(
      new Set(this.empDashboardDetails.totalPreProduced.map((item: { Price: any }) => item.Price))
    ).sort((a: any, b: any) => a - b);
    const uniqueStores = Array.from(
      new Set(this.empDashboardDetails.totalPreProduced.map((item: { ID: any }) => item.ID))
    );
    this.empDashboardDetails.totalPreProduced.forEach((item: any) => {
      this.totalItemsPreProduced += item.Qty;
    });
    uniquePrices.forEach((price) => {
      const priceData: number[] = [];
      uniqueStores.forEach((store) => {
        const qty = this.empDashboardDetails.totalPreProduced
          .filter((item: { Price: unknown; ID: unknown }) => item.Price === price && item.ID === store)
          .reduce((acc: any, curr: { Qty: any }) => acc + curr.Qty, 0);
        priceData.push(qty);
      });
      this.stackChartDataPreProduced.push(priceData);
    });
  }

  formateReportTableData(res: any) {
    const tableReport = res.items as EmployeeReport[];
    this.empReportPrices[0].prices = [];
    for (const item of tableReport) {
      const existingPriceIndex = this.empReportPrices[0].prices.findIndex(
        (price: number) => price === item.totalAmount
      );
      if (existingPriceIndex === -1) {
        this.empReportPrices[0].prices.push(item.totalAmount);
      }
    }
    this.empReportsQtys = [];

    const storeIds: number[] = [];
    tableReport.forEach((item) => { if (!storeIds.includes(item.storeId)) storeIds.push(item.storeId); });

    const globalUniqueHoursMap = new Map<string, number>();

    storeIds.forEach((storeId) => {
      const storeData: any[] = tableReport.filter((item) => item.storeId === storeId);
      const store: EmpReportQty = new EmpReportQty();
      store.id = storeData[0].userId;
      store.name = storeData[0].userName;
      store.store = storeData[0].storeName;
      storeData.forEach((item) => {
        store.qtyArray.push({ price: item.totalAmount, qty: item.totalQuantity, userName: item.userName, hours: Math.abs(item.totalHoursLogged) });
      });
      store.pieces = store.qtyArray.reduce((acc, curr) => acc + curr.qty, 0);
      store.value = store.qtyArray.reduce((acc, curr) => acc + curr.price * curr.qty, 0);
      store.apop = store.value / store.pieces;

      const uniqueHoursMap = new Map<string, Set<number>>();
      store.qtyArray.forEach((curr) => {
        if (!uniqueHoursMap.has(curr.userName)) uniqueHoursMap.set(curr.userName, new Set<number>());
        uniqueHoursMap.get(curr.userName)?.add(curr.hours);
      });
      store.hours = parseFloat(
        Array.from(uniqueHoursMap.values())
          .reduce((acc: number, hoursSet: Set<number>) => {
            const sumOfHours = Array.from(hoursSet).reduce((sum: number, hr: number) => sum + hr, 0);
            return acc + sumOfHours;
          }, 0)
          .toFixed(2)
      );
      uniqueHoursMap.forEach((hoursSet, userName) => {
        const sumOfHours = Array.from(hoursSet).reduce((sum, hr) => sum + hr, 0);
        if (!globalUniqueHoursMap.has(userName)) globalUniqueHoursMap.set(userName, sumOfHours);
      });
      store.valuePerHour = store.hours ? store.value / store.hours : 0;
      this.empReportsQtys.push(store);
    });

    this.empReportsQtys.forEach((store) => {
      let adjustedHours = 0;
      store.qtyArray.forEach((item) => {
        if (globalUniqueHoursMap.has(item.userName)) {
          adjustedHours += globalUniqueHoursMap.get(item.userName)!;
          globalUniqueHoursMap.delete(item.userName);
        }
      });
      store.hours = parseFloat(adjustedHours.toFixed(2));
    });

    this.tblReportsTotal = new EmpReportsTotal();
    this.empReportsQtys.forEach((empReport) => {
      empReport.qtyArray.forEach((item) => {
        const index = this.tblReportsTotal.totalQtyArray.findIndex((x) => x.price === item.price);
        if (index !== -1) {
          this.tblReportsTotal.totalQtyArray[index].qty += item.qty;
          this.tblReportsTotal.totalQtyArray[index].hours += item.hours;
        } else {
          this.tblReportsTotal.totalQtyArray.push({ price: item.price, qty: item.qty, hours: item.hours });
        }
      });
      this.tblReportsTotal.pieces += empReport.pieces;
      this.tblReportsTotal.value += empReport.value;
      this.tblReportsTotal.apop = this.tblReportsTotal.value / this.tblReportsTotal.pieces;
      this.tblReportsTotal.hours += parseFloat(empReport.hours.toFixed(2));
      this.tblReportsTotal.valuePerHour = parseFloat(
        (this.tblReportsTotal.hours ? this.tblReportsTotal.value / this.tblReportsTotal.hours : 0).toFixed(2)
      );
    });
  }

  formateReportExcelData(res: any) {
    const tableReport = res.items as EmpReportTable[];
    this.empReportPricesexcel[0].prices = [];
    for (const item of tableReport) {
      const existingPriceIndex = this.empReportPricesexcel[0].prices.findIndex((price: number) => price === item.price);
      if (existingPriceIndex === -1) this.empReportPricesexcel[0].prices.push(item.price);
    }
    this.empReportsQtysexcel = [];

    const userNames: { username: string; storename: string }[] = [];
    tableReport.forEach((item) => {
      const username = String(item.userName);
      const storename = String(item.store);
      const exists = userNames.some((user) => user.username === username && user.storename === storename);
      if (!exists) userNames.push({ username, storename });
    });

    const globalUniqueHoursMap = new Map<string, number>();
    userNames.forEach((usernames) => {
      const storeData: any[] = tableReport.filter(
        (item) => item.userName === usernames.username && item.store === usernames.storename
      );
      const store: EmpReportQty = new EmpReportQty();
      store.id = storeData[0].id;
      store.name = storeData[0].userName;
      store.store = storeData[0].store;
      storeData.forEach((item) => {
        store.qtyArray.push({ price: item.totalAmount, qty: item.qty, userName: item.userName, hours: Math.abs(item.totalHoursLogged) });
      });
      store.pieces = store.qtyArray.reduce((acc, curr) => acc + curr.qty, 0);
      store.value = store.qtyArray.reduce((acc, curr) => acc + (curr.price * curr.qty), 0);
      store.apop = store.value / store.pieces;

      const uniqueHoursMap = new Map<string, Set<number>>();
      store.qtyArray.forEach((curr) => {
        if (!uniqueHoursMap.has(curr.userName)) uniqueHoursMap.set(curr.userName, new Set<number>());
        uniqueHoursMap.get(curr.userName)?.add(curr.hours);
      });
      store.hours = parseFloat(
        Array.from(uniqueHoursMap.values())
          .reduce((acc: number, hoursSet: Set<number>) => {
            const sumOfHours = Array.from(hoursSet).reduce((sum: number, hr: number) => sum + hr, 0);
            return acc + sumOfHours;
          }, 0)
          .toFixed(2)
      );
      uniqueHoursMap.forEach((hoursSet, userName) => {
        const sumOfHours = Array.from(hoursSet).reduce((sum, hr) => sum + hr, 0);
        if (!globalUniqueHoursMap.has(userName)) globalUniqueHoursMap.set(userName, sumOfHours);
      });
      let adjustedHours = 0;
      store.qtyArray.forEach((item) => {
        if (globalUniqueHoursMap.has(item.userName)) {
          adjustedHours += globalUniqueHoursMap.get(item.userName)!;
          globalUniqueHoursMap.delete(item.userName);
        }
      });
      store.hours = parseFloat(adjustedHours.toFixed(2));
      store.valuePerHour = store.hours ? (store.value / store.hours) : 0;
      this.empReportsQtysexcel.push(store);
    });

    this.tblReportsTotal = new EmpReportsTotal();
    this.empReportsQtysexcel.forEach((empReport) => {
      empReport.qtyArray.forEach((item) => {
        const index = this.tblReportsTotal.totalQtyArray.findIndex((x) => x.price === item.price);
        if (index !== -1) {
          this.tblReportsTotal.totalQtyArray[index].qty += item.qty;
          this.tblReportsTotal.totalQtyArray[index].hours += item.hours;
        } else {
          this.tblReportsTotal.totalQtyArray.push({ price: item.price, qty: item.qty, hours: item.hours });
        }
      });
      this.tblReportsTotalExcel.pieces += empReport.pieces;
      this.tblReportsTotalExcel.value += empReport.value;
      this.tblReportsTotalExcel.apop = this.tblReportsTotal.value / this.tblReportsTotal.pieces;
      this.tblReportsTotalExcel.hours += parseFloat(empReport.hours.toFixed(2));
      this.tblReportsTotalExcel.valuePerHour = parseFloat(
        (this.tblReportsTotalExcel.hours ? (this.tblReportsTotalExcel.value / this.tblReportsTotalExcel.hours) : 0).toFixed(2)
      );
    });
  }

  getQuantity(qtyArray: any[] | undefined, price: number): number | string {
    const entry = qtyArray?.find((item) => item.totalAmount === price);
    return entry ? entry.qty : '-';
  }

  getFilterQuantity(qtyArray: any[] | undefined, price: number): number | string {
    const filteredItems = qtyArray?.filter((item) => item.totalAmount === price);
    if (filteredItems?.length === 0) return '-';
    const totalQty = filteredItems?.reduce((sum, item) => sum + (item.qty || 0), 0);
    return totalQty;
  }

  getColumnWiseTotalPrices(qtyArray: any[] | undefined, price: number): number | string {
    const entry = qtyArray?.find((item) => item.totalAmount === price);
    return entry ? entry.qty * entry.price : '-';
  }

  getColumnWiseHours(qtyArray: any[] | undefined, price: number): number | string {
    const entry = qtyArray?.find((item) => item.totalAmount === price);
    return entry ? entry.hours : '-';
  }

  renderChart() {
    this.destroy();
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    let totalValue = new Chart('totalValueV3', {
      type: 'bar',
      data: {
        labels: this.empDashboardDetails?.totalValue?.map((item: { Name: any }) => item.Name) || [],
        datasets: [{
          label: 'Price',
          barThickness: 25,
          data: this.empDashboardDetails?.totalValue?.map((item: { TotalValue: any }) => item.TotalValue) || [],
          backgroundColor: ['#95A4FC', '#BAEDBD', '#1C1C1C', '#B1E3FF', '#A8C5DA'],
          borderRadius: 8,
          borderSkipped: false,
        }],
      },
      options: {
        plugins: { legend: { display: false }, datalabels: { display: false } },
        layout: { padding: { bottom: 0 } },
        scales: {
          y: { beginAtZero: true, border: { display: false } },
          x: { border: { display: false }, grid: { display: false } },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });

    let totalItemCollectChart = new Chart('totalItemV3', {
      type: 'bar',
      data: {
        labels: this.stackChartLabels.map((item: string) => item),
        datasets: this.stackChartData.map((dataRow: number[], index) => ({
          data: [...dataRow],
          backgroundColor: this.getRandomColor(),
          label: 'No. of items',
          barThickness: 25,
          borderRadius: {
            bottomLeft: index == 0 ? 8 : 0,
            bottomRight: index == 0 ? 8 : 0,
            topLeft: index === this.stackChartData.length - 1 ? 8 : 0,
            topRight: index === this.stackChartData.length - 1 ? 8 : 0,
          },
        })),
      },
      options: {
        plugins: { legend: { display: false }, datalabels: { display: false } },
        scales: {
          x: { stacked: true, border: { display: false }, grid: { display: false } },
          y: { stacked: true, border: { display: false } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    let totalItemPreProducedChart = new Chart('preProducedV3', {
      type: 'bar',
      data: {
        labels: this.stackchartlabelsPreProduced.map((item: string) => item),
        datasets: this.stackChartDataPreProduced.map((dataRow: number[], index) => ({
          data: [...dataRow],
          backgroundColor: this.getRandomColor(),
          label: 'No. of items',
          barThickness: 25,
          borderRadius: {
            bottomLeft: index == 0 ? 8 : 0,
            bottomRight: index == 0 ? 8 : 0,
            topLeft: index === this.stackChartDataPreProduced.length - 1 ? 8 : 0,
            topRight: index === this.stackChartDataPreProduced.length - 1 ? 8 : 0,
          },
        })),
      },
      options: {
        plugins: { legend: { display: false }, datalabels: { display: false } },
        scales: {
          x: { stacked: true, border: { display: false }, grid: { display: false } },
          y: { stacked: true, border: { display: false } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    let projectionChartData = new Chart('projectionV3', {
      type: 'line',
      data: {
        labels: this.projectionLabels.map((item) => item),
        datasets: [
          {
            label: 'Qty',
            data: this.projectionChart.map((item: { Qty: any }) => item.Qty),
            backgroundColor: '#1C1C1C',
            borderColor: '#1C1C1C',
            pointRadius: 0,
            fill: false,
            tension: 0.1,
            borderWidth: 1,
          },
          {
            label: 'Qty',
            data: this.prevProjectionChart.map((item: { Qty: any }) => item.Qty),
            backgroundColor: '#A8C5DA',
            borderColor: '#A8C5DA',
            pointRadius: 0,
            fill: false,
            tension: 0.1,
            borderDash: [5, 5],
            borderWidth: 1,
          },
        ],
      },
      options: {
        plugins: { legend: { display: false }, datalabels: { display: false } },
        scales: {
          x: { grid: { drawOnChartArea: false } },
          y: { grid: { drawOnChartArea: false }, ticks: { stepSize: 20 } },
        },
        maintainAspectRatio: false,
        clip: false,
        responsive: true,
        interaction: { intersect: false, mode: 'index' },
      },
    });

    this.charts = [totalValue, totalItemCollectChart, totalItemPreProducedChart, projectionChartData];
  }

  destroy() {
    this.charts.forEach((chart) => { if (chart) chart.destroy(); });
    if (this.projectionChartData) this.projectionChartData.destroy();
    if (this.totalItemCollectChart) this.totalItemCollectChart.destroy();
    if (this.totalItemPreProducedChart) this.totalItemPreProducedChart.destroy();
    this.charts = [];
  }

  destroyCharts() {
    this.totalValueCollected = 0;
    this.totalItemsCollected = 0;
    this.totalItemsPreProduced = 0;
    this.stackChartData = [];
    this.stackChartDataPreProduced = [];
    this.empLevel = [{ StoreID: 0, Name: '', Qty: 0, GoalCnt: 0, totalAchieved: 0, color: '', bg: '' }];
    this.prevProjectionChart = [];
    this.projectionLabels = [];
    this.projectionChart = [];
    this.charts.forEach((chart) => { if (chart) chart.destroy(); });
    if (this.projectionChartData) this.projectionChartData.destroy();
    if (this.totalItemCollectChart) this.totalItemCollectChart.destroy();
    if (this.totalItemPreProducedChart) this.totalItemPreProducedChart.destroy();
    this.charts = [];
  }

  changeSalesData(item: string, i: number) {
    this.reportTypeOption = item;
    if (i == 0) {
      this.isSummary = false;
    } else {
      if (i == 1) {
        this.isUser = true; this.isSummary = true;
        this.outletOne = 'Nelson Wuckert'; this.outletTwo = 'Kara Hane';
      } else {
        if (i == 2) {
          this.isUser = false; this.isSummary = true;
          this.outletOne = 'NYC - 01'; this.outletTwo = 'NYC - 02';
        }
      }
    }
  }

  randomColor(): string {
    const colors = ['#95A4FC', '#BAEDBD', '#1C1C1C', '#B1E3FF', '#A8C5DA'];
    if (this.colorIndex === colors.length - 1) this.colorIndex = 0;
    else this.colorIndex++;
    return colors[this.colorIndex];
  }

  getRandomColor() {
    let color = 'hsl(' + Math.random() * 360 + ', 100%, 75%)';
    return color;
  }

  exportToExcel(): void {
    const formattedData: RowData[] = [];
    let totalPieces = 0;
    let totalValues = 0;
    let totalHours = 0;
    let totalValuePerHours = 0;
    const prices = this.empReportPricesexcel[0].prices;
    const totals: { [key: string]: number } = {};
    for (const price of prices) totals[`$${price.toFixed(2)}`] = 0;
    const Hour: { [key: string]: number } = {};
    for (const price of prices) Hour[`$${price.toFixed(2)}`] = 0;
    const ValuePerHour: { [key: string]: number } = {};
    for (const price of prices) ValuePerHour[`$${price.toFixed(2)}`] = 0;

    const processedUsers = new Map<string, number>();
    for (const item of this.empReportsQtysexcel) {
      const qtyData = this.getQtyForExcelPriceFormatting(item.qtyArray, prices);
      const HourData = this.getHourForExcelPriceFormatting(item.qtyArray, prices);
      const rowData: RowData = {
        name: item.name,
        store: item.store,
        ...qtyData,
        pieces: item.pieces,
        value: item.value,
        hours: item.hours,
        valuePerHour: item.hours ? (item.value / item.hours).toFixed(2) : 0,
        apop: (item.value / item.pieces).toFixed(2),
      };
      totalPieces += item.pieces;
      totalValues += item.value;
      const userStoreKey = `${item.name}`;
      if (!processedUsers.has(userStoreKey)) {
        totalHours += item.hours;
        processedUsers.set(userStoreKey, item.hours);
      }
      totalValuePerHours = Number(totalHours ? (totalValues / totalHours).toFixed(2) : 0);
      for (const key of Object.keys(qtyData)) {
        if (key.startsWith('$')) totals[key] += qtyData[key] !== '-' ? qtyData[key] : 0;
      }
      for (const key of Object.keys(HourData)) {
        if (key.startsWith('$')) Hour[key] += HourData[key] !== '-' ? HourData[key] : 0;
      }
      formattedData.push(rowData);
    }

    const totalQtyRow: RowData = { id: 0, name: 'Totals', ...totals, pieces: totalPieces, value: totalValues, hours: totalHours, valuePerHour: Number(totalValuePerHours.toFixed(2)), apop: totalValues / totalPieces };
    formattedData.push(totalQtyRow);
    const totalValueRow: RowData = { id: 0, name: 'Value', ...this.calculateTotalValue(totals, prices) };
    formattedData.push(totalValueRow);
    const totalQtyRow1: RowData = { id: 0, name: 'Pieces', ...totals };
    formattedData.push(totalQtyRow1);
    const hour: RowData = { id: 0, name: 'Hour', ...Hour };
    formattedData.push(hour);
    this.getValuePerHourForExcelPriceFormatting(ValuePerHour, Hour, totals, prices);
    const ratePerHourRow: RowData = { id: 0, name: '$/Hour', ...ValuePerHour };
    formattedData.push(ratePerHourRow);
    this.exportExcelService.exportAsExcelFile(formattedData, 'employee-report-v3');
  }

  fillWithZeroes(prices: number[]): any {
    const result: { [key: string]: number } = {};
    for (let i = 0; i < prices.length; i++) { result[`$${prices[i].toFixed(2)}`] = prices[i]; }
    return result;
  }

  calculateTotalValue(totals: { [key: string]: number }, prices: number[]): any {
    const result: { [key: string]: number | string } = {};
    for (const price of prices) {
      const totalQty = totals[`$${price.toFixed(2)}`];
      result[`$${price.toFixed(2)}`] = totalQty !== 0 ? totalQty * price : '-';
    }
    return result;
  }

  getQtyForExcelPriceFormatting(qtyArray: any[], prices: number[]): any {
    const result: any = {};
    for (const price of prices) {
      const qty = this.getQuantity(qtyArray, price);
      result[`$${price.toFixed(2)}`] = qty !== null ? qty : '-';
    }
    return result;
  }

  getHourForExcelPriceFormatting(qtyArray: any[], prices: number[]): any {
    const result: any = {};
    for (const price of prices) {
      const hr = this.getColumnWiseHours(qtyArray, price);
      result[`$${price.toFixed(2)}`] = hr !== null ? hr : '-';
    }
    return result;
  }

  getValuePerHourForExcelPriceFormatting(
    valuePerhours: { [key: string]: number },
    hours: { [key: string]: number },
    totals: { [key: string]: number },
    prices: number[]
  ): any {
    const result: { [key: string]: number | string } = {};
    for (let price of prices) {
      const priceKey = `$${price.toFixed(2)}`;
      const totalQty = totals[priceKey] || 0;
      result[priceKey] = totalQty !== 0 ? totalQty * price : '-';
      if (typeof result[priceKey] === 'number') {
        const totalValue = result[priceKey] as number;
        const hour = hours[priceKey] || 1;
        valuePerhours[priceKey] = parseFloat((totalValue / hour).toFixed(2));
      } else {
        valuePerhours[priceKey] = 0;
      }
    }
    return result;
  }

  onDateRangeSelected(date: DateRangeModel) {
    if (date.hour == true) {
      if (date.hourModel.isnPreviousHourWithDate == true && typeof date.hourModel.nPreviousPeriodHourWithDate === 'string') {
        let numValue = date.hourModel.nPreviousPeriodHourWithDate;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
      if (date.hourModel.isnPreviousHourWithDate == false && typeof date.hourModel.nPreviousHour === 'string') {
        let numValue = date.hourModel.nPreviousHour;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
    }
    if (date.day == true) {
      if (date.dayModel.isnPreviousDayWithDate == true && typeof date.dayModel.nPreviousPeriodDayWithDate === 'string') {
        let numValue = date.dayModel.nPreviousPeriodDayWithDate;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
      if (date.dayModel.isnPreviousDayWithDate == false && typeof date.dayModel.nPreviousDay === 'string') {
        let numValue = date.dayModel.nPreviousDay;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
    }
    if (date.week == true) {
      if (date.weekModel.isnPreviousWeekWithDate == true && typeof date.weekModel.nPreviousPeriodWeekWithDate === 'string') {
        let numValue = date.weekModel.nPreviousPeriodWeekWithDate;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
      if (date.weekModel.isnPreviousWeekWithDate == false && typeof date.weekModel.nPreviousWeek === 'string') {
        let numValue = date.weekModel.nPreviousWeek;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
    }
    if (date.month == true) {
      if (date.monthModel.isnPreviousMonthWithDate == true && typeof date.monthModel.nPreviousPeriodMonthWithDate === 'string') {
        let numValue = date.monthModel.nPreviousPeriodMonthWithDate;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
      if (date.monthModel.isnPreviousMonthWithDate == false && typeof date.monthModel.nPreviousMonth === 'string') {
        let numValue = date.monthModel.nPreviousMonth;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
    }
    if (date.quarter == true) {
      if (date.quarterModel.isnPreviousQuarterWithDate == true && typeof date.quarterModel.nPreviousPeriodQuarterWithDate === 'string') {
        let numValue = date.quarterModel.nPreviousPeriodQuarterWithDate;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
      if (date.quarterModel.isnPreviousQuarterWithDate == false && typeof date.quarterModel.nPreviousQuarter === 'string') {
        let numValue = date.quarterModel.nPreviousQuarter;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
    }
    if (date.year == true) {
      if (date.yearModel.isnPreviousYearWithDate == true && typeof date.yearModel.nPreviousPeriodYearWithDate === 'string') {
        let numValue = date.yearModel.nPreviousPeriodYearWithDate;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
      if (date.yearModel.isnPreviousYearWithDate == false && typeof date.yearModel.nPreviousYear === 'string') {
        let numValue = date.yearModel.nPreviousYear;
        if (this.containsSpecialCharacters(numValue)) { this.toaster.error('Invalid input'); return; }
      }
    }
    this.dateRangeModal = date;
    this.selectedDate();
  }

  containsSpecialCharacters(value: any) {
    const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharPattern.test(value);
  }

  validateInteger(value: any) {
    const trimmedValue = value.trim();
    if (trimmedValue === '') return false;
    const parsedValue = parseInt(trimmedValue, 10);
    if (Number.isInteger(parsedValue) && trimmedValue === parsedValue.toString()) return true;
    else return false;
  }

  get pagedEmpReports() {
    return this.empReportsQtys.slice(0, this.currentPage * this.pageSize);
  }

  get remainingCount() {
    const remaining = this.empReportsQtys.length - this.currentPage * this.pageSize;
    return remaining > 0 ? Math.min(remaining, this.pageSize) : 0;
  }

  loadMore() {
    this.currentPage++;
    this.isLoadingEmpDashboard = true;
    this.isLoadingEmpDashboard = true;
  }
}
